























































import Vue from "vue";

// vue components
import MultiCurrencyCashDetailsListTable from "@/views/App/Components/MultiCurrencyCashDetailsListTable.vue";

// model
import { MachineContent } from "@/model/data/content/MachineContent";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";
import { StockTypeEnum, stockTypeEnumLabel } from "../../../model/data/enums/StockTypeEnum";
import { StockContent } from "../../../model/data/StockContent";

export default Vue.extend({
    components: {
        MultiCurrencyCashDetailsListTable,
    },
    data() {
        return {
            StockTypeEnum,
            CashTypeEnum,
        };
    },
    props: {
        machineContent: { type: Object as () => MachineContent },
    },
    computed: {
        stockContents(): StockContent[] {
            return this.machineContent.content.stockContents;
        },
        headers(): any {
            let computedHeaders: any = [];

            computedHeaders.push(
                {
                    text: this.$t("common.stock"),
                    value: "stock",
                    class: "text-subtitle-1",
                    sortable: false,
                },
                {
                    text: this.$t("common.details"),
                    value: "details",
                    sortable: false,
                    align: "right",
                    class: "text-subtitle-1",
                }
            );

            return computedHeaders;
        },
    },
    methods: {
        stockTypeEnumLabel,

        itemRowBackground(item) {
            let itemIndex = -1;
            if (this.machineContent && this.machineContent.content && this.machineContent.content.stockContents)
                itemIndex = this.machineContent.content.stockContents.findIndex((i) => i.stockIndex == item.stockIndex && i.stockType == item.stockType);
            if (itemIndex == -1) return "";
            return this.$vuetify.breakpoint.smAndUp && itemIndex % 2 != 0 ? "greyRow" : "";
        },
    },
});
